<template>
  <div class="topic">
    <div style="margin-bottom: 20px;display: flex;">
      <el-button size="small" @click="addTab(editableTabsValue)">
        添加结果
      </el-button>
      <div class="tisp" style="margin-left:10px">提示：每个结果需单独保存</div>
    </div>
    <el-tabs
      v-model="editableTabsValue"
      type="card"
      closable
      @tab-remove="removeTab"
    >
      <el-tab-pane
        v-for="(item, index) in editableTabs"
        :key="item.name"
        :label="item.title"
        :name="item.name"
        :ref="'tab' + index"
      >
        <resultdemo
          ref="resultdemoRef"
          :ids="index"
          :resultList="resultList[index]"
          v-if="isLoaded"
        />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
  
  <script>
import resultdemo from "@/components/grade2_demo.vue";
import { getresultList,deleteTestResult } from "@/api/coupon";
export default {
  data() {
    return {
      editableTabsValue: "1",
      editableTabs: [
        {
          title: "结果1",
          name: "1",
          content: "Tab 1 content",
        },
      ],
      tabIndex: 1,
      formValues: [],
      resultList: [],
      isLoaded: false,
    };
  },
  props: ["id", "type"],
  components: {
    resultdemo,
  },
  computed: {
    isDataReady() {
      return this.resultList.length > 0;
    },
  },
  mounted() {
    this.getresultListHandel();
  },
  methods: {
    addTab(targetName) {
      let newTabName = this.editableTabs.length + 1 + "";
      console.log(newTabName, this.editableTabs);
      this.editableTabs.push({
        title: "结果" + Number(this.editableTabs.length + 1),
        name: newTabName,
        content: "New Tab content",
      });
      this.editableTabsValue = newTabName;
    },
    removeTab(targetName) {
      console.log(targetName);
      let tabs = this.editableTabs;
      let activeName = this.editableTabsValue;
      if (activeName === targetName) {
        tabs.forEach((tab, index) => {
          if (tab.name === targetName) {
            let nextTab = tabs[index + 1] || tabs[index - 1];
            if (nextTab) {
              activeName = nextTab.name;
            }
          }
        });
      }

      this.editableTabsValue = activeName;
      this.editableTabs = tabs.filter((tab) => tab.name !== targetName);
      if(this.resultList.length != 0){
        let num = Number(targetName) -1
        let arr = this.resultList[num]
        console.log(arr);
        let data = {
        test_id:this.id,
        result_id:arr.id
      }
      deleteTestResult(data).then((res)=>{
        console.log(res);
        if(res.code ==1){
          this.$message({
            message: "恭喜你，删除成功",
            type: "success",
          });
        }else{
          setTimeout(()=>{
            location.reload();
          },1000)
        }
      })
      }
    },
    getresultListHandel() {
      let data = {
        test_id: this.id,
      };
      getresultList(data).then((res) => {
        this.resultList = res.data;
        console.log(res);
        // this.editableTabs.length = this.resultList.length;
        //  this.addtab();
        if (res.code == 1) {
          this.handleLoadingComplete()
          if (res.data.length != 0) {
            this.editableTabs = this.resultList.map((item, index) => {
              let newTabName = index;
              return {
                title: "结果" + Number(index + 1),
                name: index + 1 + "",
                content: "New Tab content",
              };
            });
          }
        }else{
          this.handleLoadingComplete()
        }
      });
    },
    handleLoadingComplete() {
      // 根据你的实际情况进行判断，如果所有接口都加载完毕，将isLoaded设置为true
      this.isLoaded = true;
    },
  },
};
</script>
  
  <style>
</style>